var modules_7fc2511b = {"dots":"_1lhmxyc","pagination-button":"_1gllfvr","selected-page":"_bpsard"};
import "../../../assets/BEV45u6G.css";

export { modules_7fc2511b as default };
//# sourceMappingURL=PaginationButton.module.less.js.map
